import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import API_BASE_URL from '../utils/config';
import gstCategories from '../pages/gst/GSTCategoryList'; // adjust path as needed


export default function AddOrEditProduct() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const [formData, setFormData] = useState({
    name: '',
    category: '',
    hsn_code: '',
    price: '',
    stock: '',
     gst_category_id: ''
  });

  useEffect(() => {
    if (id) {
      axios.get(`${API_BASE_URL}/api/products`, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(res => {
        const product = res.data.find(p => p.id === parseInt(id));
        if (product) setFormData(product);
      });
    }
  }, [id]);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (id) {
      await axios.put(`${API_BASE_URL}/api/products/${id}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } else {
      await axios.post(`${API_BASE_URL}/api/products`, formData, {
  headers: { Authorization: `Bearer ${token}` }
});
    }
    navigate('/products');
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <h2 className="text-2xl font-bold mb-4">{id ? 'Edit' : 'Add'} Product</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Name" required className="w-full border px-3 py-2 rounded" />
        <input type="text" name="category" value={formData.category} onChange={handleChange} placeholder="Category" className="w-full border px-3 py-2 rounded" />
        <input type="text" name="hsn_code" value={formData.hsn_code} onChange={handleChange} placeholder="HSN Code" className="w-full border px-3 py-2 rounded" />
        <input type="number" name="price" value={formData.price} onChange={handleChange} placeholder="Price" required className="w-full border px-3 py-2 rounded" />
        <input type="number" name="stock" value={formData.stock} onChange={handleChange} placeholder="Stock" required className="w-full border px-3 py-2 rounded" />
        <select
  value={formData.gst_category_id}
  onChange={(e) =>
    setFormData({ ...formData, gst_category_id: parseInt(e.target.value) })
  }
>
  {gstCategories.map((cat) => (
    <option key={cat.id} value={cat.id}>
      {cat.name} ({cat.gst_percent}%)
    </option>
  ))}
</select>
        <button className="bg-blue-600 text-white px-4 py-2 rounded">{id ? 'Update' : 'Add'} Product</button>
      </form>
    </div>
  );
}